<!-- Básica -->
<div class="row" *ngIf="isBasica">
  <div class="col-lg col-md col-xs col-xl col-sm w-100">
    <mat-card class="mat-elevation-z8 w-100">
      <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
        <div class="row">
          <div class="col-lg col-md col-xs col-xl col-sm">
            <p class="tituloLeft">{{ step }}</p>
          </div>
          <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
            <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
              *ngIf="!collapseCard"></i>
            <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
              *ngIf="collapseCard"></i>
          </div>
        </div>
        <mat-card-content *ngIf="!collapseCard">
          <div class="row pt-3">
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Site Beneficiamento</mat-label>
                <mat-select #txtMotRepr formControlName="site" disableCenteringOption disabled class="InputBlockColor">
                  <input matInput type="text" class="form-control filterTxt" placeholder="Pesquisar por..."
                    (keyup)="createFilterSite($event.target.value)" />
                  <mat-option *ngFor="let item of listSite" [value]="item.initials">
                    {{ item.initials | uppercase }}
                  </mat-option>
                </mat-select>
                <i matSuffix class="{{ iconDisableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{
                  hintCalc
                  }}</mat-hint>
                <mat-error>
                  {{ hasErrorFormControl(formulario.controls.site) }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">{{
                  hintSafraLabel
                  }}</mat-label>
                <input matInput id="txtSafra" #txtSafra maxlength="8" formControlName="safra" class="InputUnblockColor"
                  (blur)="getPc003Data()" />
                <i matSuffix class="{{ iconEnableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{
                  hintSafra
                  }}</mat-hint>
                <mat-hint align="end">{{ txtSafra.value.length }} / 8</mat-hint>
                <mat-error>{{
                  hasErrorFormControl(formulario.controls.safra)
                  }}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Número do Campo<span class="InputRequired">{{required}}</span>
                </mat-label>
                <input matInput id="txtNumeroCampo" #txtNumeroCampo maxlength="20" currencyMask
                  [options]="{ thousands: '', decimal: '', precision: 0 }" formControlName="numero_campo"
                  (blur)="getPc003Data()">
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.numero_campo)}}</mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="row pt-3">
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Data</mat-label>
                <input matInput id="txtData" #txtData maxlength="10" mask="d0/M0/0000" formControlName="data" />
                <i matSuffix class="{{ iconEnableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{
                  hintDate
                  }}</mat-hint>
                <mat-hint align="end">{{ txtData.value.length }} / 10</mat-hint>
                <mat-error>{{ hasErrorFormControl(formulario.controls.data) }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Hora</mat-label>
                <input matInput id="txtHora" #txtHora maxlength="5" mask="Hh:m0" formControlName="hora" />
                <i matSuffix class="{{ iconEnableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{
                  hintHour
                  }}</mat-hint>
                <mat-hint align="end">{{ txtHora.value.length }} / 5</mat-hint>
                <mat-error>{{ hasErrorFormControl(formulario.controls.hora) }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="row pt-3">
            <div class="col-lg col-md">
              <mat-form-field *ngIf="!dropdownLoteds and listLoteDs.length == 0" class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Lote Ds</mat-label>
                <input matInput id="txtLoteDs" #txtLoteDs maxlength="11"  formControlName="lote_ds">
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                <mat-hint align="end">{{txtLoteDs.value.length}} / 11</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.lote_ds)}}</mat-error>
              </mat-form-field>
              <mat-form-field *ngIf="dropdownLoteds and listLoteDs.length > 0" class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Lote Ds</mat-label>
                <mat-select #txtLoteDs formControlName="lote_ds"
                  disableCenteringOption>
                  <input matInput type="text" class="form-control filterTxt" placeholder="Pesquisar por..."
                    (keyup)="createFilterProcesso($event.target.value)" />
                  <mat-option *ngFor="let item of listLoteDs" [value]="item.name">
                    {{ item.name | uppercase }}
                  </mat-option>
                </mat-select>
                <i matSuffix class="{{ iconEnableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                <mat-error>
                  {{ hasErrorFormControl(formulario.controls.processo_basica) }}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Número Controle</mat-label>
                <input matInput id="txtNumContrl" #txtNumContrl maxlength="10" formControlName="numero_controle"
                  currencyMask [options]="{ thousands: '.', decimal: ',', precision: 0 }" readonly
                  class="InputBlockColor" />
                <i matSuffix class="{{ iconDisableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{ hintControle }}
                </mat-hint>
                <mat-hint align="end">{{ txtNumContrl.value.length }} / 10</mat-hint>
                <mat-error>{{
                  hasErrorFormControl(formulario.controls.numero_controle)
                  }}</mat-error>
              </mat-form-field>
            </div>


          </div>

          <div class="row pt-3">
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Processo</mat-label>
                <mat-select #txtProcesso formControlName="processo_basica" (selectionChange)="changePeneira()"
                  disableCenteringOption>
                  <input matInput type="text" class="form-control filterTxt" placeholder="Pesquisar por..."
                    (keyup)="createFilterProcesso($event.target.value)" />
                  <mat-option *ngFor="let item of listProcesso" [value]="item.name">
                    {{ item.name | uppercase }}
                  </mat-option>
                </mat-select>
                <i matSuffix class="{{ iconEnableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                <mat-error>
                  {{ hasErrorFormControl(formulario.controls.processo_basica) }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Híbrido/Linhagem</mat-label>
                <input matInput id="txtHibrido" #txtHibrido maxlength="40" formControlName="hibrido_rnc" readonly
                  class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                <mat-error>
                  {{hasErrorFormControl(formulario.controls.hibrido_rnc)}}
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="row pt-3">
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Classe</mat-label>
                <mat-select #txtPeneira formControlName="classe" disableCenteringOption>
                  <input matInput type="text" class="form-control filterTxt" placeholder="Pesquisar por..."
                    (keyup)="createFilterClasses($event.target.value)" />
                  <mat-option *ngFor="let item of listClasses" [value]="item.name">
                    {{ item.name | uppercase }}
                  </mat-option>
                </mat-select>
                <i matSuffix class="{{ iconEnableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                <mat-error>{{
                  hasErrorFormControl(formulario.controls.classe)
                  }}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Peneira</mat-label>
                <mat-select #txtPeneira formControlName="peneira_basica" disableCenteringOption>
                  <input matInput type="text" class="form-control filterTxt" placeholder="Pesquisar por..."
                    (keyup)="createFilterPeneira($event.target.value)" />
                  <mat-option *ngFor="let item of listPeneira" [value]="item.name">
                    {{ item.name | uppercase }}
                  </mat-option>
                </mat-select>
                <i matSuffix class="{{ iconEnableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                <mat-error>{{
                  hasErrorFormControl(formulario.controls.peneira_basica)
                  }}</mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="row pt-3">
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Umidade média do DS (%)<span
                    class="InputRequired">{{required}}</span>
                </mat-label>
                <input matInput id="txtUmidadeMedia" #txtUmidadeMedia maxlength="20" currencyMask
                  [options]="{ thousands: '', decimal: '', precision: 0 }" formControlName="umidade_media">
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.umidade_media)}}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Geração</mat-label>
                <input matInput id="txtGeracao" #txtGeracao maxlength="50" formControlName="geracao" readonly
                  class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">
                </mat-hint>
                <mat-hint align="end">{{txtGeracao.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.geracao)}}
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="row pt-3">
            <div class="col-lg col-md" *ngIf="!formulario.controls.vazao.disabled">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Vazão Classificação (ton/h)</mat-label>
                <input matInput type="number" id="vazao" #txtVazao maxlength="20" formControlName="vazao" />
                <i matSuffix class="{{ iconEnableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{ hintNumber }}
                </mat-hint>
                <mat-error>{{ hasErrorFormControl(formulario.controls.vazao) }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Linha de Processamento</mat-label>
                <mat-select #txtLinhaProcessamento formControlName="linha_processamento" disableCenteringOption>
                  <input matInput type="text" class="form-control filterTxt" placeholder="Pesquisar por..."
                    (keyup)="createFilterLinhaProcessamento($event.target.value)" />
                  <mat-option *ngFor="let item of listLinhaProcessamento" [value]="item.name">
                    {{ item.name | uppercase }}
                  </mat-option>
                </mat-select>
                <i matSuffix class="{{ iconEnableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                <mat-error>
                  {{ hasErrorFormControl(formulario.controls.linha_processamento) }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>



        </mat-card-content>
      </form>
    </mat-card>
  </div>
</div>

<!-- Comercial -->
<div class="row" *ngIf="isComercial">
  <div class="col-lg col-md col-xs col-xl col-sm w-100">
    <mat-card class="mat-elevation-z8 w-100">
      <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
        <div class="row">
          <div class="col-lg col-md col-xs col-xl col-sm">
            <p class="tituloLeft">{{ step }}</p>
          </div>
          <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
            <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
              *ngIf="!collapseCard"></i>
            <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
              *ngIf="collapseCard"></i>
          </div>
        </div>
        <mat-card-content *ngIf="!collapseCard">
          <div class="row pt-3">
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Site Beneficiamento</mat-label>
                <mat-select #txtMotRepr formControlName="site" disableCenteringOption disabled class="InputBlockColor">
                  <input matInput type="text" class="form-control filterTxt" placeholder="Pesquisar por..."
                    (keyup)="createFilterSite($event.target.value)" />
                  <mat-option *ngFor="let item of listSite" [value]="item.initials">
                    {{ item.initials | uppercase }}
                  </mat-option>
                </mat-select>
                <i matSuffix class="{{ iconDisableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{
                  hintCalc
                  }}</mat-hint>
                <mat-error>
                  {{ hasErrorFormControl(formulario.controls.site) }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">{{
                  hintSafraLabel
                  }}</mat-label>
                <input matInput id="txtSafra" #txtSafra maxlength="8" formControlName="safra"
                  class="InputUnblockColor" />
                <i matSuffix class="{{ iconEnableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{
                  hintSafra
                  }}</mat-hint>
                <mat-hint align="end">{{ txtSafra.value.length }} / 8</mat-hint>
                <mat-error>{{
                  hasErrorFormControl(formulario.controls.safra)
                  }}</mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="row pt-3">
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Data</mat-label>
                <input matInput id="txtData" #txtData maxlength="10" mask="d0/M0/0000" formControlName="data" />
                <i matSuffix class="{{ iconEnableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{
                  hintDate
                  }}</mat-hint>
                <mat-hint align="end">{{ txtData.value.length }} / 10</mat-hint>
                <mat-error>{{ hasErrorFormControl(formulario.controls.data) }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Hora</mat-label>
                <input matInput id="txtHora" #txtHora maxlength="5" mask="Hh:m0" formControlName="hora" />
                <i matSuffix class="{{ iconEnableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{
                  hintHour
                  }}</mat-hint>
                <mat-hint align="end">{{ txtHora.value.length }} / 5</mat-hint>
                <mat-error>{{ hasErrorFormControl(formulario.controls.hora) }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="row pt-3">
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Número Controle</mat-label>
                <input matInput id="txtNumContrl" #txtNumContrl maxlength="10" formControlName="numero_controle"
                  currencyMask [options]="{ thousands: '.', decimal: ',', precision: 0 }" readonly
                  class="InputBlockColor" />
                <i matSuffix class="{{ iconDisableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{ hintControle }}
                </mat-hint>
                <mat-hint align="end">{{ txtNumContrl.value.length }} / 10</mat-hint>
                <mat-error>{{
                  hasErrorFormControl(formulario.controls.numero_controle)
                  }}</mat-error>
              </mat-form-field>
            </div>

            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Híbrido</mat-label>
                <mat-select #txtHibrido formControlName="hibrido" disableCenteringOption>
                  <input matInput type="text" class="form-control filterTxt" placeholder="Pesquisar por..."
                    (keyup)="createFilterHibrido($event.target.value)" />
                  <mat-option *ngFor="let item of listHibrido" [value]="item.name">
                    {{ item.name | uppercase }}
                  </mat-option>
                </mat-select>
                <i matSuffix class="{{ iconEnableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                <mat-error>
                  {{ hasErrorFormControl(formulario.controls.hibrido) }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="row pt-3">
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Processo</mat-label>
                <mat-select #txtProcesso formControlName="processo" disableCenteringOption>
                  <input matInput type="text" class="form-control filterTxt" placeholder="Pesquisar por..."
                    (keyup)="createFilterProcesso($event.target.value)" />
                  <mat-option *ngFor="let item of listProcesso" [value]="item.name">
                    {{ item.name | uppercase }}
                  </mat-option>
                </mat-select>
                <i matSuffix class="{{ iconEnableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                <mat-error>
                  {{ hasErrorFormControl(formulario.controls.processo) }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Lote Origem</mat-label>
                <input matInput id="txtLoteOrigem" #txtLoteOrigem maxlength="40" formControlName="lote_origem" />
                <i matSuffix class="{{ iconEnableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">
                </mat-hint>
                <mat-hint align="end">{{ txtLoteOrigem.value.length }} / 40</mat-hint>
                <mat-error>{{
                  hasErrorFormControl(formulario.controls.lote_origem)
                  }}</mat-error>
              </mat-form-field>
            </div>
            <!-- <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Lote Ds</mat-label>
                                <input matInput id="txtLoteDs" #txtLoteDs maxlength="11" formControlName="lote_ds">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-hint align="end">{{txtLoteDs.value.length}} / 11</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.lote_ds)}}</mat-error>
                            </mat-form-field>
                        </div> -->
          </div>

          <div class="row pt-3">
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Lote Cs</mat-label>
                <input matInput id="txtLoteCs" #txtLoteCs maxlength="11" formControlName="lote_cs" />
                <i matSuffix class="{{ iconEnableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                <mat-hint align="end">{{ txtLoteCs.value.length }} / 11</mat-hint>
                <mat-error>{{
                  hasErrorFormControl(formulario.controls.lote_cs)
                  }}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg col-md">
              <!-- <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Origem</mat-label>
                                <mat-select #txtHibrido formControlName="origem" disableCenteringOption>
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..."
                                        (keyup)="createFilterOrigem($event.target.value)">
                                    <mat-option *ngFor="let item of listOrigem" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-error>f
                                    {{hasErrorFormControl(formulario.controls.origem)}}
                                </mat-error>
                            </mat-form-field> -->
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Origem</mat-label>
                <input matInput id="txtOrigem" #txtOrigem maxlength="11" formControlName="origem" />
                <i matSuffix class="{{ iconEnableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                <mat-hint align="end">{{ txtOrigem.value.length }} / 11</mat-hint>
                <mat-error>{{
                  hasErrorFormControl(formulario.controls.origem)
                  }}</mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="row pt-3">
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Peneira</mat-label>
                <mat-select #txtPeneira formControlName="peneira" disableCenteringOption
                  (selectionChange)="makeCalculations()">
                  <input matInput type="text" class="form-control filterTxt" placeholder="Pesquisar por..."
                    (keyup)="createFilterPeneira($event.target.value)" />
                  <mat-option *ngFor="let item of listPeneira" [value]="item.name">
                    {{ item.name | uppercase }}
                  </mat-option>
                </mat-select>
                <i matSuffix class="{{ iconEnableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                <mat-error>{{
                  hasErrorFormControl(formulario.controls.peneira)
                  }}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Destino</mat-label>
                <input matInput id="txtDestino" #txtDestino maxlength="11" formControlName="destino" />
                <i matSuffix class="{{ iconEnableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                <mat-hint align="end">{{ txtDestino.value.length }} / 11</mat-hint>
                <mat-error>{{
                  hasErrorFormControl(formulario.controls.destino)
                  }}</mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-6 pt-3">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                  floatLabel="{{formFieldFloatLabel}}">
                  <mat-label class="InputLabelColor">Turno</mat-label>
                  <mat-select #txtTurno formControlName="turno" disableCenteringOption>
                      <input matInput type="text" class="form-control filterTxt"
                          placeholder="Pesquisar por..." (keyup)="createFilterTurno($event.target.value)">
                      <mat-option *ngFor="let item of listTurno" [value]="item.name">
                          {{item.name | uppercase}}
                      </mat-option>
                  </mat-select>
                  <i matSuffix class="{{iconEnableField}}"></i>
                  <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                  <mat-error>
                      {{hasErrorFormControl(formulario.controls.turno)}}
                  </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="row pt-3">
            <div class="col-md-6" *ngIf="!formulario.controls.basic.disabled">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Campo (Básica)</mat-label>
                <input matInput type="number" id="basic" #txtBasic maxlength="20" formControlName="basic" />
                <i matSuffix class="{{ iconEnableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{ hintNumber }}
                </mat-hint>
                <mat-error>{{ hasErrorFormControl(formulario.controls.basic) }}
                </mat-error>
              </mat-form-field>
            </div>
            <!-- Campo Geração (Não esta sendo renderizado no front)-->
            <div class="col-md-6" *ngIf="!formulario.controls.generation_id.disabled">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Geração</mat-label>
                <mat-select formControlName="generation_id" (selectionChange)="generationChange($event)">
                  <input matInput type="text" class="form-control filterTxt" placeholder="Selecione..." />
                  <mat-option *ngFor="let item of listGeneration" [value]="item.id">
                    {{ item.name | uppercase }}
                  </mat-option>
                </mat-select>
                <i matSuffix class="{{ iconEnableField }}"></i>
                <mat-error>{{ hasErrorFormControl(formulario.controls.basic) }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="row pt-3">
            <div class="col-6" *ngIf="!formulario.controls.vazao.disabled">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Vazão</mat-label>
                <input matInput type="number" id="vazao" #txtVazao maxlength="20" formControlName="vazao" />
                <i matSuffix class="{{ iconEnableField }}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{ hintNumber }}
                </mat-hint>
                <mat-error>{{ hasErrorFormControl(formulario.controls.vazao) }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-6" *ngIf="!formulario.controls.responsavel_especial.disabled">
              <mat-form-field class="w-100" appearance="{{ formFieldAppearance }}"
                floatLabel="{{ formFieldFloatLabel }}">
                <mat-label class="InputLabelColor">Responsável por Liberação Especial</mat-label>
                <input matInput type="text" id="responsavel_especial" #txtResponsavelEspecial maxlength="40"
                  formControlName="responsavel_especial" />
                <i matSuffix class="{{ iconEnableField }}"></i>
                <mat-error>{{ hasErrorFormControl(formulario.controls.responsavel_especial) }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <!-- <div class="row pt-3">
                        <div class="col-md-6" *ngIf="!formulario.controls.porcentagem_falha.disabled">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">% Falha</mat-label>
                                <input matInput id="txtPorcetagemFalha" #txtPorcetagemFalha maxlength="10"
                                    formControlName="porcentagem_falha" currencyMask>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                                </mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.porcentagem_falha)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div> -->

          <!-- <div class="row pt-3">
                        <div class="col-lg-6 col-md-6">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Umidade do DS (%)</mat-label>
                                <input matInput id="txtUmidDs" #txtUmidDs maxlength="10"
                                    formControlName="umidade_ds_prc" currencyMask>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
                                </mat-hint>
                                <mat-hint align="end">{{txtUmidDs.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.umidade_ds_prc)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div> -->
        </mat-card-content>
      </form>
    </mat-card>
  </div>
</div>
